import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchSections, fetchedSections } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchSections>;

export function* getSectionsSaga({ meta: { callback } }: FetchActionPayload) {
  const { getSections } = getAPI();
  const response: YieldOf<typeof getSections> = yield call(getSections);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedSections(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedSections(undefined, error));
  }

  if (callback) callback();
}

export default function* sectionsSaga() {
  yield takeLatest(fetchSections.type, getSectionsSaga);
}
